import React, { useState } from "react";
import CateringSettelment from "./CateringSettelment";
import Cateringsoverview from "../Caterings/Cateringsoverview";

const TabsLayout = () => {
  const [activeTab, setActiveTab] = useState("Vendor Settlement");

  const DummySection = ({ title }) => (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );

  const renderComponent = () => {
    switch (activeTab) {
      // case "Overview":
      //   return <Cateringsoverview />;
      case "Vendor Settlement":
        return <CateringSettelment />;
    //   case "Summery":
    //     return <Foodsubscribedclients title="Summery" />;
     
      default:
        return <CateringSettelment />;
    }
  };

  const tabs = [
    // "Overview",
    "Vendor Settlement",
    
  
  ];

  return (
    <div className="tabs-wrapper">
      {/* TOP ONE-ROW TABS (ALL SCREENS) */}
      <div className="tabs-row">
        {tabs.map((tab) => (
          <span
            key={tab}
            className={`row-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </span>
        ))}
      </div>

      {/* CONTENT */}
      <div className="tabs-content">
        {renderComponent()}
      </div>
    </div>
  );
};

export default TabsLayout;

